export default {
  // Común
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    search: 'Buscar',
    reset: 'Restablecer',
    export: 'Exportar',
    import: 'Importar',
    upload: 'Subir',
    download: 'Descargar',
    submit: 'Enviar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    refresh: 'Actualizar',
    loading: 'Cargando...',
    noData: 'Sin Datos',
    success: 'Operación exitosa',
    error: 'Operación fallida',
    warning: 'Advertencia',
    info: 'Información',
    index: 'Índice',
    actions: 'Acciones',
    total: 'Total {total} elementos',
	year:'año',
	month:'Luna',
	day:'Día',
	jidu:'trimestre'
  },
  
  // Inicio de sesión
  login: {
    title: 'Inicio de Sesión',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    loginSuccess: 'Inicio de sesión exitoso',
    loginFailed: 'Inicio de sesión fallido',
    notLoggedIn: 'No ha iniciado sesión...',
    systemTitle: 'Tecnología Ambiental Qinghe · Sistema de Gestión de Generadores de Hidrógeno',
    welcomeTitle: 'Bienvenido - Sistema de Gestión de Generadores de Hidrógeno',
    usernameMinLength: 'El nombre de usuario debe tener al menos 2 caracteres',
    passwordFormat: 'Formato de contraseña inválido',
    verificationCode: 'Error de código de verificación (distingue mayúsculas y minúsculas)',
    getUserInfoFailed: 'Error al obtener información del usuario'
  },

  // Inicio de sesión de organización
  orgLogin: {
    title: 'Tecnología Ambiental Qinghe - Gestión de Organizaciones',
    welcomeTitle: 'Bienvenido - Sistema de Gestión de Organizaciones',
    username: 'Cuenta',
    password: 'Contraseña',
    usernamePlaceholder: 'Por favor ingrese la cuenta',
    passwordPlaceholder: 'Por favor ingrese la contraseña',
    loginButton: 'Iniciar Sesión Ahora',
    usernameRequired: 'Por favor ingrese la cuenta',
    passwordRequired: 'Por favor ingrese la contraseña',
    usernameMinLength: 'La cuenta debe tener al menos 2 caracteres',
    passwordFormat: 'Formato de contraseña inválido',
    loginSuccess: 'Inicio de sesión exitoso',
    loginFailed: 'Inicio de sesión fallido'
  },

  // Menú de organización
  orgMenu: {
    home: 'Inicio',
    dataManagement: 'Gestión de Datos',
    equipment: 'Gestión de Equipos',
    equipmentForeign: 'Gestión de Equipos',
    filterRecord: 'Registro de Filtros',
    waterCard: 'Gestión de Tarjetas de Agua',
    mqttQuery: 'Consulta de Datos MQTT',
    deviceStatus: 'Consulta de Estado del Dispositivo',
    waterTotal: 'Consulta de Total de Agua',
    waterRecord: 'Consulta de Registro de Agua',
    customerManagement: 'Gestión de Clientes',
    customerList: 'Lista de Clientes',
    customerForeign: 'Gestión de Clientes',
    customerData: 'Consulta de Datos de Clientes'
  },
  
  orgDashboard: {
    title: 'Panel de Control de Organización',
    welcome: 'Bienvenido al Sistema de Gestión de Máquinas de Hidrógeno',
    deviceCount: 'Total de Dispositivos',
    onlineDevices: 'Dispositivos en Línea',
    filterChanges: 'Cambios de Filtro',
    waterOutput: 'Total de Salida de Agua',
    recentActivities: 'Actividades Recientes',
    quickActions: 'Acciones Rápidas',
    manageDevices: 'Gestión de Dispositivos',
    viewFilterRecords: 'Registros de Filtros',
    checkStatus: 'Consulta de Estado',
    viewWaterRecords: 'Registros de Agua',
    waterStatistics: 'Estadísticas de Agua',
    orgName: 'Nombre de la Organización',
    outWaterTotal: 'Salida de Agua',
    period: 'Período',
    reportType: {
      day: 'Diario',
      week: 'Semanal',
      month: 'Mensual',
      quarter: 'Trimestral',
      year: 'Anual',
      custom: 'Personalizado'
    },
    prevButton: {
      day: 'Día Anterior',
      week: 'Semana Anterior',
      month: 'Mes Anterior',
      quarter: 'Trimestre Anterior',
      year: 'Año Anterior'
    },
    nextButton: {
      day: 'Día Siguiente',
      week: 'Semana Siguiente',
      month: 'Mes Siguiente',
      quarter: 'Trimestre Siguiente',
      year: 'Año Siguiente'
    },
    datePicker: {
      rangeSeparator: 'a',
      startPlaceholder: 'Fecha de Inicio',
      endPlaceholder: 'Fecha de Fin',
      currentWeek: 'Esta Semana'
    }
  },
  
  waterTotal: {
    equId: 'ID del Dispositivo',
    export: 'Exportar',
    equIdPlaceholder: 'Por favor ingrese el ID del dispositivo',
    equIdRequired: 'El ID del dispositivo es requerido',
    volumnTTLOD: 'Volumen Total',
    waterRecord: 'Registro de Agua',
    queryFailed: 'Consulta fallida'
  },
  
  // Página de administración
  admin: {
    title: 'Tecnología Ambiental Qinghe - Administración',
    dashboard: 'Panel de control',
    menu: 'Menú',
    logout: 'Cerrar sesión',
    resetPassword: 'Restablecer Contraseña'
  },
  
  // Gestión de dispositivos
  device: {
    title: 'Gestión de Dispositivos',
    list: 'Lista de Dispositivos',
    add: 'Agregar Dispositivo',
    edit: 'Editar Dispositivo',
    delete: 'Eliminar Dispositivo',
    status: 'Estado del Dispositivo',
    type: 'Tipo de Dispositivo',
    online: 'En línea',
    offline: 'Desconectado',
    heartbeat: 'Datos de Latido',
    record: 'Registro de Operación',
    activate: 'Registro de Activación'
  },
  
  // Gestión de organizaciones
  org: {
    title: 'Gestión de Organizaciones',
    list: 'Lista de Organizaciones',
    add: 'Agregar Organización',
    edit: 'Editar Organización',
    delete: 'Eliminar Organización',
    name: 'Nombre de la Organización',
    code: 'Código de la Organización',
    type: 'Tipo de Organización'
  },
  
  // Gestión de tarjetas de agua
  card: {
    title: 'Gestión de Tarjetas de Agua',
    list: 'Lista de Tarjetas de Agua',
    add: 'Agregar Tarjeta de Agua',
    bind: 'Vincular Tarjeta de Agua',
    unbind: 'Desvincular Tarjeta de Agua',
    import: 'Importar Tarjeta de Agua',
    export: 'Exportar Tarjeta de Agua',
    serialNo: 'Número de Serie',
    cardNo: 'Número de Tarjeta',
    status: 'Estado'
  },
  
  // Configuración del sistema
  setting: {
    title: 'Configuración del Sistema',
    general: 'Configuración General',
    security: 'Configuración de Seguridad',
    notification: 'Configuración de Notificaciones'
  },
  
  // Estadísticas de datos
  stats: {
    title: 'Estadísticas de Datos',
    tds: 'Estadísticas TDS',
    volume: 'Estadísticas de Volumen',
    usage: 'Estadísticas de Uso'
  },
  
  // Pie de página
  footer: {
    copyright: '© 2023 - Tecnología Ambiental Qinghe Co., Ltd. Todos los derechos reservados',
    icp: 'Registro ICP: ',
    techSupport: '© Soporte Técnico: Guangzhou Guanjun Hydrogen Technology Co., Ltd.'
  },
  
  // Mensajes de error
  error: {
    network: 'Error de Red',
    server: 'Error del Servidor',
    permission: 'Permisos Insuficientes',
    param: 'Error de Parámetro',
    notFound: 'Datos No Encontrados',
    pageNotFound: 'Lo siento, la página que visitó no existe'
  },
  
  // Menú relacionado
  menu: {
    // Gestión de Dispositivos
    equipment: 'Biblioteca de Equipos y Filtros',
    filterRecord: 'Registro de Cambio de Filtros',
    version: 'Biblioteca de Versiones Domésticas',
    dataQuery: 'Consulta de Datos TCP',
    heartbeat: 'Datos de Latido',
    singleUse: 'Datos de Uso Único',
    bindStats: 'Estadísticas de Vinculación',
    
    // Gestión de Clientes
    customer: 'Gestión de Clientes',
    agentCheck: 'Revisión de Agentes',
    agentProfit: 'Gestión de Beneficios de Agentes',
    promotionRoute: 'Configuración de Ruta de Promoción',
    partyType: 'Gestión de Tipo de Partido',
    
    // Consulta de Datos MQTT
    mqttQuery: 'Consulta de Datos MQTT',
    statusQuery: 'Consulta de Estado',
    outputRecord: 'Consulta de Registro de Salida',
    debug: 'Página de Depuración de Dispositivos',
    waterTotal: 'Consulta de Total de Agua',
    
    // Gestión del Sistema
    adminAccount: 'Cuenta de Administrador',
    deviceType: 'Gestión de Tipo de Dispositivo',
    defaultSettings: 'Configuración Predeterminada del Sistema',
    flowConfig: 'Personalización de Flujo de Agua',
    waterConfig: 'Configuración de Temperatura y Agua',
    businessLog: 'Registro de Negocios',
    
    // Gestión de Pagos
    payment: 'Gestión de Pagos',
    order: 'Gestión de Pedidos',
    statistics: 'Estadísticas de Datos',
    waterPrice: 'Configuración de Precio del Agua',
    recharge: 'Recarga'
  },

  // Gestión de Equipos de Organización
  orgEquipment: {
    deviceId: 'ID del Dispositivo',
    deviceIdPlaceholder: 'Por favor ingrese el ID del dispositivo',
    status: 'Estado',
    statusPlaceholder: 'Por favor seleccione el estado',
    allStatus: 'Todos los Estados',
    used: 'Usado',
    unused: 'No Usado',
    repairing: 'En Reparación',
    repairCompleted: 'Reparación Completada',
    none: 'Ninguno',
    deviceType: 'Tipo de Dispositivo',
    deviceTypePlaceholder: 'Por favor seleccione el tipo de dispositivo',
    allTypes: 'Todos los Tipos',
    homeDevice: '▣Dispositivo Doméstico',
    sharedDevice: '▣Dispositivo Compartido',
    homeFilter: '☍Filtro Doméstico',
    sharedFilter: '☍Filtro Compartido',
    other: 'Otro',
    generateDate: 'Fecha de Generación',
    datePlaceholder: 'Por favor seleccione la fecha',
    exportDevices: 'Exportar Dispositivos',
    iotCard: 'Tarjeta IoT',
    generateTime: 'Tiempo de Generación',
    activateTime: 'Tiempo de Activación',
    onlineStatus: 'Estado en Línea',
    online: 'En Línea',
    offline: 'Desconectado',
    filterReminder: 'Recordatorio de Filtro',
    filterNumber: 'Filtro Número',
    remainingWater: 'Agua Restante',
    lastHeartbeat: 'Último Latido',
    qrCode: 'Código QR',
    associatedDevice: 'Dispositivo Asociado',
    notBound: 'No Vinculado',
    changeCard: 'Cambiar Tarjeta',
    queryLocation: 'Consultar Ubicación',
    screenPassword: 'Contraseña de Pantalla',
    changeStatus: 'Cambiar Estado',
    changeLocation: 'Cambiar Ubicación',
    rechargeWater: 'Recargar Agua',
    rechargeRecord: 'Registro de Recarga',
    iotCardPlaceholder: 'Por favor ingrese el número de tarjeta IoT',
    iotCardRequired: 'El número de tarjeta IoT es requerido',
    statusRequired: 'Por favor seleccione el estado',
    remark: 'Observación',
    remarkPlaceholder: 'Por favor ingrese la observación',
    cityName: 'Nombre de la Ciudad',
    cityNamePlaceholder: 'Por favor ingrese el nombre de la ciudad',
    cityNameRequired: 'El nombre de la ciudad es requerido',
    cityCode: 'Código de la Ciudad',
    cityCodePlaceholder: 'Por favor ingrese el código de la ciudad',
    cityCodeRequired: 'El código de la ciudad es requerido',
    rechargeVolume: 'Volumen de Recarga',
    rechargeVolumePlaceholder: 'Por favor ingrese el volumen de recarga',
    rechargeVolumeRequired: 'El volumen de recarga es requerido',
    rechargeVolumeMin: 'El volumen de recarga debe ser mayor que 0',
    rechargeSuccess: 'Recarga exitosa',
    orgIdRequired: 'El ID de la organización no puede estar vacío',
    transferOrg: 'Transferir Organización',
    receiveOrg: 'Organización Receptora',
    selectSubordinate: 'Por favor seleccione la organización subordinada',
    selectSubordinateRequired: 'Por favor seleccione la organización subordinada',
    transferOrgRequired: 'Por favor seleccione la organización receptora',
    transferOrgSuccess: 'Transferencia de organización exitosa',
    deviceOfflineCannotModifyPassword: 'El dispositivo está desconectado, no se puede modificar la contraseña',
    deviceOfflineCannotRecharge: 'El dispositivo está desconectado, no se puede realizar la operación de recarga',
    deviceIdRequired: 'El ID del dispositivo no puede estar vacío',
    ml: 'ml',
    rechargeTip: '(Volumen de recarga predeterminado: 68500L por vez)',
    recharge: 'Recargar',
    password: 'Contraseña',
    passwordPlaceholder: 'Por favor ingrese la contraseña',
    passwordRequired: 'La contraseña es requerida',
    unknown: 'Desconocido',
    offlineDays: 'Días Desconectado ≥',
    offlineDaysPlaceholder: 'Por favor ingrese los días desconectado',
    province: 'Provincia',
    city: 'Ciudad',
    district: 'Distrito',
    selectProvince: 'Por favor seleccione la provincia',
    selectCity: 'Por favor seleccione la ciudad',
    selectDistrict: 'Por favor seleccione el distrito',
    selectCityRequired: 'Por favor seleccione la ciudad',
    volPre: 'Volumen Anterior',
    volNext: 'Volumen Siguiente',
    rechargeTime: 'Tiempo de Recarga',
    operator: 'Operador',
    more: 'Más',
    machineLock: 'Bloquear Máquina',
    machineUnlock: 'Desbloquear Máquina',
    machineRestart: 'Reiniciar Máquina',
    factoryReset: 'Restablecer de Fábrica',
    confirmLock: '¿Está seguro de bloquear este dispositivo?',
    confirmUnlock: '¿Está seguro de desbloquear este dispositivo?',
    confirmRestart: '¿Está seguro de reiniciar este dispositivo?',
    confirmFactoryReset: '¿Está seguro de restablecer de fábrica este dispositivo? ¡Esta operación no se puede deshacer!',
    controlSuccess: 'Operación exitosa',
    controlFailed: 'Operación fallida'
  },

  // Consulta de Registro de Agua MQTT
  statusDetail: {
    title: 'Consulta de Datos de Pedido MQTT',
    equId: 'ID del Dispositivo',
    equIdPlaceholder: 'Por favor ingrese el ID del dispositivo',
    equIdRequired: 'El ID del dispositivo es requerido',
    requestId: 'ID del Registro de Agua',
    operaTime: 'Tiempo de Creación',
    type: 'Tipo de Agua',
    bagful: 'Bolsas del Pedido',
    volumn: 'Volumen por Bolsa·L',
    outwaterTime: 'Tiempo de Agua',
    bagfulOD: 'Bolsas Reales',
    volumnTTLOD: 'Volumen Total·L',
    closewaterTime: 'Tiempo de Fin',
    status: 'Estado del Pedido',
    waterDetail: 'Detalle del Agua',
    queryFailed: 'Consulta Fallida',
    detailFailed: 'Error al Obtener Detalle',
    iceWater: 'Agua Helada',
    normalWater: 'Agua Normal',
    warmWater45: 'Agua 45℃',
    warmWater75: 'Agua 75℃',
    hotWater95: 'Agua 95℃',
    other: 'Otro',
    created: 'Pedido Creado',
    watering: 'Regando',
    completed: 'Completado',
    abnormalClose: 'Cierre Anormal',
    detailRequestId: 'Número de Pedido',
    detailBagful: 'Número de Bolsa',
    detailVolumn: 'Volumen por Bolsa·L',
    volumnOD: 'Volumen Real·L',
    usedTimeOD: 'Tiempo Usado·seg',
    detailClosewaterTime: 'Tiempo de Finalización'
  },

  // Registro de Cambio de Filtros
  filterRecord: {
    title: 'Consulta de Registros de Cambio de Filtros de Dispositivos',
    equipmentId: 'ID del Dispositivo',
    enterEquipmentId: 'Por favor ingrese el ID del dispositivo',
    equipmentIdRequired: 'El ID del dispositivo es requerido',
    equipmentType: 'Tipo de Dispositivo',
    allTypes: 'Todos los Tipos',
    filterType: 'Tipo de Filtro',
    changeTime: 'Tiempo de Cambio',
    changeReason: 'Razón del Cambio',
    changePerson: 'Persona que Cambió',
    remark: 'Observación',
    homeFilter: 'Filtro Doméstico',
    sharedFilter: 'Filtro Compartido',
    unknown: 'Desconocido',
    filterId: 'ID del Filtro',
    filterNumber: 'Número de Filtro',
    number: 'Número',
    filter: 'Filtro',
    waterDetail: 'Detalle del Agua',
    orderNumber: 'Número de Pedido',
    bagNumber: 'Número de Bolsa',
    waterPerBag: 'Agua por Bolsa (ml)',
    actualWater: 'Salida de Agua Real (ml)',
    timeUsed: 'Tiempo Usado (seg)',
    completionTime: 'Tiempo de Finalización'
  },

  // Consulta de Estado del Dispositivo MQTT
  statusAdmin: {
    title: 'Consulta de Estado del Dispositivo MQTT',
    equId: 'ID del Dispositivo',
    equIdPlaceholder: 'Por favor ingrese el ID del dispositivo',
    equIdRequired: 'Por favor ingrese el ID del dispositivo',
    onLineStatus: 'Estado en Línea',
    heartbitStatus: 'Estado de la Máquina',
    digitalInput: 'Entrada Digital',
    digitalOutput: 'Salida Digital',
    waterMachineStep: 'Paso de la Máquina de Agua',
    errStatus: 'Código de Error',
    active: 'Tiempo de Activación',
    volumn: 'Volumen de Uso·ml',
    waterRecord: 'Registro de Agua',
    filterRecord: 'Registro de Filtros',
    deviceDetail: 'Detalle del Dispositivo',
    online: 'Dispositivo en Línea',
    offline: 'Dispositivo Desconectado',
    notActivated: 'Dispositivo No Activado',
    noInput: 'Sin Entrada',
    noOutput: 'Sin Salida',
    none: 'Ninguno',
    queryFailed: 'Consulta Fallida',
    orgName: 'Nombre de la Organización',
    orgCode: 'Código de la Organización',
    orgType: 'Tipo',
    status: 'Estado',
    orgAddress: 'Dirección de la Organización',
    orgLinkName: 'Contacto de la Organización',
    orgLinkPhone: 'Teléfono de la Organización',
    orgNumber: 'Número de la Organización',
    orgUrl: 'URL de Licencia Comercial',
    orgOwner: 'Nombre Legal',
    orgOwnerUrl: 'Foto de ID Legal',
    orgOwnerID: 'Número de ID Legal',
    orgOwnerPhone: 'Teléfono Legal',
    createTime: 'Tiempo de Creación',
    updateTime: 'Tiempo de Actualización',
    checkTime: 'Tiempo de Verificación',
    deleteTime: 'Tiempo de Eliminación',
    remark: 'Observación',
    official: 'Oficial',
    agent: 'Agente',
    dealer: 'Distribuidor',
    valid: 'Válido',
    invalid: 'Inválido',
    deleted: 'Eliminado'
  },

  // Gestión de Clientes
  orgAdmin: {
    customerName: 'Nombre del Cliente',
    customerNamePlaceholder: 'Por favor ingrese el nombre del cliente',
    keyword: 'Palabra Clave',
    keywordPlaceholder: 'Por favor ingrese la palabra clave',
    type: 'Tipo',
    status: 'Estado',
    allTypes: 'Tipo (Todos)',
    allStatus: 'Estado (Todos)',
    agent: 'Agente',
    dealer: 'Distribuidor',
    official: 'Oficial',
    valid: 'Válido',
    invalid: 'Inválido',
    deleted: 'Eliminado',
    other: 'Otro',
    add: 'Agregar',
    detail: 'Detalle',
    edit: 'Editar',
    viewSecret: 'Ver Secreto',
    delete: 'Eliminar',
    copy: 'Copiar',
    treeMode: 'Vista de árbol (expandir/colapsar jerarquía)',
    expandAll: 'Expandir Todo',
    collapseAll: 'Colapsar Todo',
    addOrg: 'Agregar Organización',
    editOrg: 'Editar Organización',
    orgName: 'Nombre de la Organización',
    orgNamePlaceholder: 'Por favor ingrese el nombre de la organización',
    orgCode: 'Código de la Organización',
    orgCodePlaceholder: 'Por favor ingrese el código de la organización',
    orgType: 'Tipo de Organización',
    address: 'Dirección de la Organización',
    addressPlaceholder: 'Por favor ingrese la dirección de la organización',
    contact: 'Persona de Contacto',
    contactPlaceholder: 'Por favor ingrese la persona de contacto',
    phone: 'Teléfono de Contacto',
    phonePlaceholder: 'Por favor ingrese el teléfono de contacto',
    normalUser: 'Usuario Normal',
    orgNumber: 'Número de la Organización',
    businessLicense: 'URL de Licencia Comercial',
    legalName: 'Nombre de la Persona Legal',
    legalIdPhoto: 'Foto de ID de la Persona Legal',
    legalIdNumber: 'Número de ID de la Persona Legal',
    legalPhone: 'Teléfono de la Persona Legal',
    remark: 'Observación',
    createTime: 'Tiempo de Creación',
    updateTime: 'Tiempo de Actualización',
    checkTime: 'Tiempo de Verificación',
    deleteTime: 'Tiempo de Eliminación',
    manageId: 'ID de Gestión',
    secretId: 'Secret ID',
    secretKey: 'Secret Key',
    orgNameRequired: 'Por favor ingrese el nombre de la organización',
    orgCodeRequired: 'Por favor ingrese el código de la organización',
    orgTypeRequired: 'Por favor seleccione el tipo de organización',
    statusRequired: 'Por favor seleccione el estado',
    deleteConfirm: '¿Está seguro de eliminar?',
    deleteSuccess: 'Eliminación exitosa',
    saveSuccess: 'Guardado exitoso',
    copySuccess: 'Copia exitosa',
    copyFailed: 'Copia fallida',
    uploadBusinessLicense: 'Subir Licencia Comercial',
    uploadLegalIdPhoto: 'Subir ID de la Persona Legal',
    viewImage: 'Ver Imagen',
    noImage: 'Sin Imagen',
    uploadImageOnly: 'Solo se pueden subir archivos de imagen',
    uploadSizeLimit: 'El tamaño de la imagen no puede exceder 10MB',
    uploadSuccess: 'Subida exitosa',
    uploadFailed: 'Subida fallida',
    addChild: 'Agregar Organización Hija',
    parentOrg: 'Organización Padre',
    childOrg: 'Organización Hija',
    selectChildOrg: 'Por favor seleccione la organización hija',
    childOrgRequired: 'Por favor seleccione la organización hija',
    remarkPlaceholder: 'Por favor ingrese la observación',
    addChildSuccess: 'Agregar organización hija exitoso',
    addChildFailed: 'Agregar organización hija fallido',
    currentOrgNotFound: 'No se encontró la organización actualmente conectada',
    orgInfoError: 'Error de información de la organización',
    orgIdRequired: 'El ID de la organización no puede estar vacío',
    cannotSameOrg: 'La organización padre y la organización hija no pueden ser la misma',
    rechargeWater: 'Recargar Agua',
    fromOrg: 'Desde Organización',
    toOrg: 'Hacia Organización',
    currentBalance: 'Balance Actual',
    balanceHint: '(Las organizaciones de nivel 1 no tienen límite, otras no pueden exceder el balance)',
    selectSubordinate: 'Por favor seleccione la organización subordinada',
    selectSubordinateRequired: 'Por favor seleccione la organización subordinada',
    waterAmount: 'Cantidad de Agua',
    waterAmountPlaceholder: 'Por favor ingrese la cantidad de agua',
    waterAmountRequired: 'Por favor ingrese la cantidad de agua',
    waterAmountMin: 'La cantidad de agua debe ser mayor que 0',
    insufficientBalance: 'Balance insuficiente, balance actual: {balance}ml, requerido: {amount}ml',
    rechargeSuccess: 'Recarga exitosa',
    rechargeFailed: 'Recarga fallida',
    waterBalance: 'Balance de Agua'
  },

  // Restablecer Contraseña
  resetPassword: {
    title: 'Restablecer Contraseña',
    username: 'Cuenta',
    usernamePlaceholder: 'Por favor ingrese la cuenta',
    usernameRequired: 'Por favor ingrese la cuenta',
    oldPassword: 'Contraseña Anterior',
    oldPasswordPlaceholder: 'Por favor ingrese la contraseña anterior',
    oldPasswordRequired: 'Por favor ingrese la contraseña anterior',
    newPassword: 'Nueva Contraseña',
    newPasswordPlaceholder: 'Por favor ingrese la nueva contraseña',
    newPasswordRequired: 'Por favor ingrese la nueva contraseña',
    confirmPassword: 'Confirmar Nueva Contraseña',
    confirmPasswordPlaceholder: 'Por favor ingrese la nueva contraseña nuevamente',
    confirmPasswordRequired: 'Por favor ingrese la nueva contraseña nuevamente',
    passwordRequired: 'Por favor ingrese la contraseña',
    passwordFormat: 'La contraseña debe tener entre 6 y 12 caracteres y no puede contener espacios',
    passwordMismatch: 'Las dos contraseñas no coinciden',
    resetSuccess: 'Contraseña restablecida exitosamente',
    resetFailed: 'Error al restablecer la contraseña'
  }
}
